function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { CART_NOTIFIER_LOAD_SUCCESS } from 'moduleCartNotifier/constants';
import { ADD_TO_CART, ADD_TO_CART_WITH_FORMAT, CART_DELETE_ALL_COMPLETE, CART_DELETE_ITEM_COMPLETE, CART_PAY_COMPLETE, REMOVE_FROM_CART, REMOVE_FROM_CART_WITH_FORMAT } from 'moduleCart/constants';
import { DEAL_REPEAT_SUCCESS } from 'modules/deal/constants';
var defaultState = {}; // eslint-disable-next-line default-param-last

var reducerCartNotifier = function reducerCartNotifier() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case CART_NOTIFIER_LOAD_SUCCESS:
      {
        var payload = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          count: payload.count
        });
      }

    case ADD_TO_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          count: state.count + 1
        });
      }

    case REMOVE_FROM_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          count: state.count - 1
        });
      }

    case ADD_TO_CART_WITH_FORMAT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          count: state.count + 1
        });
      }

    case REMOVE_FROM_CART_WITH_FORMAT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          count: state.count - 1
        });
      }

    case CART_DELETE_ITEM_COMPLETE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          count: state.count - 1
        });
      }

    case CART_DELETE_ALL_COMPLETE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          count: 0
        });
      }

    case CART_PAY_COMPLETE:
      {
        var _payload = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          count: state.count - _payload.ids.length
        });
      }

    case DEAL_REPEAT_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          count: state.count + 1
        });
      }

    default:
      return state;
  }
};

export { reducerCartNotifier };